
import React from 'react'
import {  Button, Modal  } from "react-bootstrap";
import { PropTypes } from 'prop-types'
import {  change  } from 'redux-form'
import { warning } from './constants'


const ModalWindow = ({ title, message,trigger, dispatch }) => {
    function handleModalClose() {
        dispatch(change('eventinfo',trigger,false))
    }
    return(
        <Modal show style={{ position:'absolute',top:'40%', left:'1%', transform: 'translate(-40%, -1%) !important' }} onHide={handleModalClose}>
        <Modal.Header closeButton>
            <Modal.Title style={{ color:warning }}>
                <i className="fa fa-exclamation-triangle" aria-hidden="true" />&nbsp;{title}
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
           <p>{message}</p>
        </Modal.Body>
        <Modal.Footer>
            <Button onClick={handleModalClose}>Close</Button>
        </Modal.Footer>
        </Modal>
    )
}

ModalWindow.propTypes = {
   title: PropTypes.string.isRequired,
   message:PropTypes.string.isRequired,
   trigger:PropTypes.string,
   dispatch:PropTypes.func
}

export default ModalWindow


// WEBPACK FOOTER //
// ./src/utils/modalwindow.js